import { watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

/**
 * When a session ends while the app is open, go to the sign-in page.
 *
 * The router only checks for a session when navigating, so a session ended
 * mid-page, by the server or by choosing Sign out, left the person on the
 * page they were on, emptied by the signed-out layout. After an ended
 * session the page is kept to come back to; after choosing to sign out it is
 * not, so whoever signs in next does not land on the last person's page.
 */
export function useSignOutRedirect() {
  const auth = useAuthStore()
  const route = useRoute()
  const router = useRouter()
  watch(
    () => auth.isSignedIn,
    async (now, before) => {
      if (!before || now || route.meta.public) return
      if (auth.signedOut === 'chosen') await router.replace({ name: 'sign-in' })
      else await router.replace({ name: 'sign-in', query: { next: route.fullPath } })
    },
  )
}
